export class ApplicationContactDTO {
  applicationContactId: number;
  contactTypeCode: string;
  contactValue: string;
  isPreferred: boolean;
}